module.exports = "/_next/static/images/platform_3-d675aa6e600796a62f54db10bffbbeeb.png";